module.exports = __webpack_public_path__ + "img/wenjian.abe699d0.png";